import { EArtAncillaryType, EArtAncillaryTypeNameLowerCase } from 'constants/ArtAccessoryType';
import { ELegalEntityTypes } from 'constants/LegalEntityTypes';
import { ESize, IGaleryFormValues } from 'models/galery';
import { ERouteLinks } from 'models/route';

export const initialData: IGaleryFormValues = {
  entryIdsForRemoval: [],
  entryParameters: [],
};

export const getBreadcrumbs = (
  t: any,
  isEdit: boolean,
  id: string,
  type: string | null,
  artType: string | EArtAncillaryTypeNameLowerCase,
  url?: ERouteLinks,
) => {
  if (!url) return [];
  const title = isEdit ? t('manageImages.editPhoto.label') : t('manageImages.addPhoto.label');

  switch (url) {
    case ERouteLinks.LegalEntityAddImages:
    case ERouteLinks.LegalEntityEditImages:
      return [
        { label: t('module.legalEntity.name'), route: ERouteLinks.LegalEntities },
        {
          label:
            type === ELegalEntityTypes.individual
              ? t('legalEntities.individual.accordion.label')
              : t('legalEntities.organization.accordion.label'),
          route: `${ERouteLinks.LegalEntities}?expand=${type}`,
        },
        {
          label: t('legalEntityDetails.legalEntityDetails.text'),
          route: `${ERouteLinks.ViewLegalEntity.replace(':id', id)}?type=${type}`,
        },
        title,
      ];
    case ERouteLinks.FRTAddImages:
    case ERouteLinks.FRTEditImages:
      return [
        {
          label: t('firearms.registeredFirearms.breadcrumbs.firearms'),
          route: ERouteLinks.Firearms,
        },
        {
          label: t('firearmsReferenceTable.firearmDetails.firearmDetails.header'),
          route: `${ERouteLinks.Firearms}?expand=frt`,
        },
        {
          label: t('firearmsReferenceTable.editFirearm.viewLocalFirearm.header'),
          route: `${ERouteLinks.FRTDetails.replace(':frtId', id)}`,
        },
        title,
      ];
    case ERouteLinks.AncillariesAddImages:
    case ERouteLinks.AncillariesEditImages:
      let optionName = '';
      let detailsLabel = '';
      if (artType === EArtAncillaryTypeNameLowerCase.ACCESSORY) {
        optionName = EArtAncillaryType.ACCESSORIES;
        detailsLabel = 'accessoryDetails.accordion.title.label';
      } else if (artType === EArtAncillaryTypeNameLowerCase.AMMUNITION) {
        optionName = EArtAncillaryType.AMMUNITION;
        detailsLabel = 'ammunitionDetails.accordion.title.label';
      } else if (artType === EArtAncillaryTypeNameLowerCase.COMPONENTS) {
        optionName = EArtAncillaryType.COMPONENTS;
        detailsLabel = 'componentDetails.accordion.title.label';
      }
      return [
        {
          label: t('module.ancillaries.name'),
          route: ERouteLinks.Ancillaries,
        },
        {
          label: t('module.ancillariesreferencetable.name'),
          route: `${ERouteLinks.Ancillaries}?expand=ancillaries-reference-table&ancillaryOptionName=${optionName}`,
        },
        {
          label: t(detailsLabel),
          route: `${ERouteLinks.ViewAncillaries.replace(':type', artType).replace(
            ':id',
            id as string,
          )}`,
        },
        title,
      ];
    case ERouteLinks.FirearmAddImages:
    case ERouteLinks.FirearmEditImages:
      return [
        {
          label: t('firearms.registeredFirearms.accordion.name'),
          route: ERouteLinks.Firearms,
        },
        {
          label: t('registeredFirearms.firearmsDetails.header'),
          route: `${ERouteLinks.ViewRegisteredFirearm.replace(':id', id as string)}`,
        },
        title,
      ];
    case ERouteLinks.AccessoriesAddImages:
    case ERouteLinks.AccessoriesEditImages:
      return [
        {
          label: t('module.ancillaries.name'),
          route: ERouteLinks.Ancillaries,
        },
        {
          label: t('module.accessories.name'),
          route: `${ERouteLinks.Ancillaries}?expand=accessories`,
        },
        {
          label: t('accessoryDetails.accordion.title.label'),
          route: `${ERouteLinks.ViewAccessories.replace(':id', id as string)}`,
        },
        title,
      ];
    case ERouteLinks.ComponentsAddImages:
    case ERouteLinks.ComponentsEditImages:
      return [
        {
          label: t('module.ancillaries.name'),
          route: ERouteLinks.Ancillaries,
        },
        {
          label: t('module.components.name'),
          route: `${ERouteLinks.Ancillaries}?expand=components`,
        },
        {
          label: t('componentsDetails.accordion.title.label'),
          route: `${ERouteLinks.ViewComponents.replace(':id', id as string)}`,
        },
        title,
      ];
    case ERouteLinks.AmmunitionAddImages:
    case ERouteLinks.AmmunitionEditImages:
      return [
        {
          label: t('module.ancillaries.name'),
          route: ERouteLinks.Ancillaries,
        },
        {
          label: t('module.ammunition.name'),
          route: `${ERouteLinks.Ancillaries}?expand=ammunition`,
        },
        {
          label: t('ammunitionDetails.accordion.title.label'),
          route: `${ERouteLinks.ViewAmmunition.replace(':id', id as string)}`,
        },
        title,
      ];
    default:
      return [];
  }
};

export const getPrevLink = (
  id: string,
  type: string | null,
  artType: string | EArtAncillaryTypeNameLowerCase,
  url?: ERouteLinks,
): string => {
  if (!url) return '';
  switch (url) {
    case ERouteLinks.LegalEntityAddImages:
    case ERouteLinks.LegalEntityEditImages:
      return `${ERouteLinks.ViewLegalEntity.replace(':id', id)}?type=${type}`;
    case ERouteLinks.FRTAddImages:
    case ERouteLinks.FRTEditImages:
      return ERouteLinks.FRTDetails.replace(':frtId', id);
    case ERouteLinks.AncillariesAddImages:
    case ERouteLinks.AncillariesEditImages:
      return ERouteLinks.ViewAncillaries.replace(':type', artType).replace(
        ':id',
        id as string,
      );
    case ERouteLinks.FirearmAddImages:
    case ERouteLinks.FirearmEditImages:
      return ERouteLinks.ViewRegisteredFirearm.replace(':id', id as string);
    case ERouteLinks.AmmunitionAddImages:
    case ERouteLinks.AmmunitionEditImages:
      return ERouteLinks.ViewAmmunition.replace(':id', id as string);
    case ERouteLinks.ComponentsAddImages:
    case ERouteLinks.ComponentsEditImages:
      return ERouteLinks.ViewComponents.replace(':id', id as string);
    case ERouteLinks.AccessoriesAddImages:
    case ERouteLinks.AccessoriesEditImages:
      return ERouteLinks.ViewAccessories.replace(':id', id as string);
    default:
      return '';
  }
};

export const getSizeImage = (url?: ERouteLinks): ESize => {
  switch (url) {
    case ERouteLinks.LegalEntityAddImages:
    case ERouteLinks.LegalEntityEditImages:
      return ESize.THUMBNAIL;
    case ERouteLinks.FRTAddImages:
    case ERouteLinks.FRTEditImages:
    case ERouteLinks.AncillariesAddImages:
    case ERouteLinks.AncillariesEditImages:
    case ERouteLinks.FirearmAddImages:
    case ERouteLinks.FirearmEditImages:
    case ERouteLinks.AmmunitionAddImages:
    case ERouteLinks.AmmunitionEditImages:
    case ERouteLinks.ComponentsAddImages:
    case ERouteLinks.ComponentsEditImages:
    case ERouteLinks.AccessoriesAddImages:
    case ERouteLinks.AccessoriesEditImages:
      return ESize.THUMBNAIL_SQRT;
    default:
      return ESize.THUMBNAIL_SQRT;
  }
};
export const getSizeFullImage = (url?: ERouteLinks): ESize => {
  switch (url) {
    case ERouteLinks.LegalEntityAddImages:
    case ERouteLinks.LegalEntityEditImages:
      return ESize.FULL;
    case ERouteLinks.FRTAddImages:
    case ERouteLinks.FRTEditImages:
    case ERouteLinks.AncillariesAddImages:
    case ERouteLinks.AncillariesEditImages:
    case ERouteLinks.FirearmAddImages:
    case ERouteLinks.FirearmEditImages:
      return ESize.FULL_SQRT;
    default:
      return ESize.FULL_SQRT;
  }
};
